<button
  type="button"
  [class]="
    'flex items-center w-full text-left transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed ' +
    'gap-(--row-button-gap) px-(--row-button-padding-x) py-(--row-button-padding-y) font-(family-name:--row-button-font-family) ' +
    (disabled() ? 'pointer-events-none ' : '') +
    (config().variant === 'primary'
      ? 'bg-(--row-button-primary-background) rounded-(--row-button-primary-border-radius) hover:bg-(--row-button-primary-hover-background)'
      : 'bg-(--row-button-secondary-background) rounded-(--row-button-secondary-border-radius) hover:bg-(--row-button-secondary-hover-background)')
  "
  [class.shadow-(--row-button-shadow)]="config().shadow"
  [style.border]="
    config().border
      ? config().variant === 'primary'
        ? '1px solid var(--row-button-primary-border-color)'
        : '1px solid var(--row-button-secondary-border-color)'
      : 'none'
  "
  [disabled]="disabled()"
  (click)="onClick()"
>
  @if (config().leadingMedia) {
    <img
      [src]="config().leadingMedia"
      alt=""
      [class]="
        'w-12 h-12 shrink-0 object-cover ' +
        (config().variant === 'primary'
          ? 'rounded-(--row-button-primary-border-radius)'
          : 'rounded-(--row-button-secondary-border-radius)')
      "
    />
  }

  @if (config().leadingIcon) {
    <app-icon
      [name]="config().leadingIcon!"
      [color]="
        config().variant === 'primary'
          ? 'var(--row-button-primary-icon-color)'
          : 'var(--row-button-secondary-icon-color)'
      "
      class="w-6 h-6 shrink-0"
    ></app-icon>
  }

  <div
    class="flex-1 flex flex-col gap-1 overflow-hidden"
    [style.gap]="config().contentGap"
  >
    @if (config().title) {
      <app-dynamic-text
        [config]="{
          text: config().title!,
          size: config().titleSize || 'base',
          fontWeight: config().titleFontWeight || 'bold',
          fontFamily: 'var(--row-button-title-font-family, var(--font-sans))',
          whiteSpace: config().whiteSpace,
          color:
            config().variant === 'primary'
              ? 'var(--row-button-primary-title-color)'
              : 'var(--row-button-secondary-title-color)',
        }"
      />
    }
    @if (config().supportingText) {
      <app-dynamic-text
        [config]="{
          text: config().supportingText!,
          fontWeight: config().titleFontWeight || 'bold',
          lineHeight: config().supportingTextLineHeight || 'var(--leading-tight)',
          whiteSpace: config().whiteSpace,
          cssVarPrefix:
            config().variant === 'primary'
              ? 'row-button-primary-supporting-text'
              : 'row-button-secondary-supporting-text',
          color:
            config().variant === 'primary'
              ? 'var(--row-button-primary-supporting-text-color)'
              : 'var(--row-button-secondary-supporting-text-color)',
        }"
      />
    }
    @if (config().metadata) {
      <app-dynamic-text
        [config]="{
          text: config().metadata!,
          size: 'base',
          fontWeight: config().metadataFontWeight || 'semibold',
          whiteSpace: config().whiteSpace,
          color:
            config().variant === 'primary'
              ? 'var(--row-button-primary-metadata-color)'
              : 'var(--row-button-secondary-metadata-color)',
        }"
      />
    }
    @if (config().mediaObject) {
      <div class="w-full flex items-center gap-2">
        @if (config().mediaObject!.avatar || config().mediaObject!.icon || config().mediaObject!.initials) {
          <app-avatar
            [config]="{
              size: AvatarSize.SM,
              imageUrl: config().mediaObject!.avatar,
              icon: config().mediaObject!.icon,
              initials: config().mediaObject!.initials,
            }"
          />
        }
        <div class="flex-1 flex flex-col overflow-hidden">
          <app-dynamic-text
            [config]="{
              text: config().mediaObject!.title,
              size: 'sm',
              fontWeight: config().titleFontWeight || 'bold',
              whiteSpace: config().whiteSpace,
              color:
                config().variant === 'primary'
                  ? 'var(--row-button-primary-title-color)'
                  : 'var(--row-button-secondary-title-color)',
            }"
          />
          @if (config().mediaObject!.date) {
            <app-dynamic-text
              [config]="{
                text: config().mediaObject!.date!,
                size: 'sm',
                fontWeight: config().titleFontWeight || 'bold',
                whiteSpace: config().whiteSpace,
                cssVarPrefix:
                  config().variant === 'primary'
                    ? 'row-button-primary-supporting-text'
                    : 'row-button-secondary-supporting-text',
                color:
                  config().variant === 'primary'
                    ? 'var(--row-button-primary-supporting-text-color)'
                    : 'var(--row-button-secondary-supporting-text-color)',
              }"
            />
          }
        </div>
      </div>
    }
    @if (config().chip) {
      <app-dynamic
        componentName="Chip"
        [props]="{ config: config().chip }"
      />
    }
  </div>

  @if (config().price) {
    <app-dynamic-text
      class="shrink-0"
      [config]="{
        text: config().price!,
        fontWeight: 'bold',
        whiteSpace: config().whiteSpace,
        color:
          config().variant === 'primary'
            ? 'var(--row-button-primary-price-color)'
            : 'var(--row-button-secondary-price-color)',
      }"
    />
  }

  @if (config().showChevron) {
    <app-icon
      name="caret-right"
      size="16"
      [color]="
        config().variant === 'primary'
          ? 'var(--row-button-primary-chevron-color)'
          : 'var(--row-button-secondary-chevron-color)'
      "
      class="shrink-0"
    ></app-icon>
  }
</button>
